import { useState, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import loadable from '@utils/loadable';

const SentimentMiniChart = loadable(() => import('../../SentimentMiniChart'));

const TopicClassBox = (props) => {
  const [sectionInView, setInView] = useState(false);
  const { topic, activePeriod } = props;

  const { ref, inView } = useInView({
    skip: sectionInView,
  });

  useEffect(() => {
    if (inView) {
      setInView(true);
    }
  }, [inView]);

  return (
    <div ref={ref}>
      <SentimentMiniChart
        isTopic
        isTopicClass
        showTooltipOutside
        title={topic.title}
        topic={topic}
        slugType="AssetClass"
        inView={sectionInView}
        activePeriod={activePeriod}
      />
    </div>
  );
};

export default TopicClassBox;
